import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setSelectedMember} from '../../manageusers/ManageUserSlice'
import Rights from '../../../../../libs/utility/Rights';
import Checkbox from '../../../../components/checkbox/basecheckbox/Checkbox';
import Label from '../../../../components/label/Label';
import styles from "./RightsSection.styles"
import { PERMISSION_GROUP } from '../../constant';

export default function RightsSection() {
    const { selectedMember, disabledFields } = useSelector((state) => state[componentKey]);
    const groupedPermissions =  Rights.groupPermissions(selectedMember);
    const dispatch = useDispatch();

    const handlePermissionChange = (key, checked) =>{
      dispatch(setSelectedMember({...selectedMember, [key]: checked}))
    }

    const handleBulkPermissionChange = (key, checked) => {
      let selectedMemberCopy = {...selectedMember}
      
      if(key === PERMISSION_GROUP.PEOPLE){
        Object.keys(groupedPermissions[PERMISSION_GROUP.PEOPLE]).forEach(child=>{
          groupedPermissions[PERMISSION_GROUP.PEOPLE][child].forEach((val)=> {
            selectedMemberCopy = {...selectedMemberCopy, [val.key]: checked} 
          })
        })
      }
      else if (key === PERMISSION_GROUP.PAYER|| key === PERMISSION_GROUP.RECIPIENT || key === PERMISSION_GROUP.USER){
        groupedPermissions[PERMISSION_GROUP.PEOPLE][key].forEach((val)=> {
          selectedMemberCopy = {...selectedMemberCopy, [val.key]: checked}
        })
      }
      else{
        groupedPermissions[key].forEach((child) => {
          selectedMemberCopy = {...selectedMemberCopy, [child.key]: checked}
        })

      }
      dispatch(setSelectedMember({...selectedMemberCopy}))
    }

    const isAllSelected = (key) => {
      let result = true;
      if(key === PERMISSION_GROUP.PEOPLE){
        Object.keys(groupedPermissions[PERMISSION_GROUP.PEOPLE]).forEach(child=>{
          groupedPermissions[PERMISSION_GROUP.PEOPLE][child].forEach((val)=> {
            if(val.value === false) {
              result = false;
              return;
            }
          } )
        })
      }
      else if (key === PERMISSION_GROUP.PAYER || key === PERMISSION_GROUP.RECIPIENT || key === PERMISSION_GROUP.USER){
        groupedPermissions[PERMISSION_GROUP.PEOPLE][key].forEach((val)=> {
          if(val.value === false) {
            result = false;
            return;
          }
        } )
      }
      else {
          groupedPermissions[key].forEach((permission) => {
            if(permission.value === false) {
              result = false;
              return;
            }
          })
      }
      return result;
    }

    const isDisabled = (key) => {
      if(disabledFields.includes(key)){
        return true
      }
      return false
    }

  return (
    <div style={styles.fullWidth}>
    <div style={styles.checkBox}>
      <div style={styles.column}>
        <div style={styles.columnHeader}>
          <Checkbox checked={isAllSelected(PERMISSION_GROUP.PEOPLE)} onChangeCb={(e)=> handleBulkPermissionChange(PERMISSION_GROUP.PEOPLE, e.target.checked)} />
          <Label>{PERMISSION_GROUP.PEOPLE}</Label> 
        </div>
        <div style={styles.columnBody}>
          {
          Object.keys(groupedPermissions[PERMISSION_GROUP.PEOPLE]).map((people)=>
          <div style={{...styles.columnBody, paddingBottom: '20px'}}>
            <div style={styles.checkBox}>
              <Checkbox checked={isAllSelected(people)} onChangeCb={(e)=> handleBulkPermissionChange(people, e.target.checked)} />
              <Label>{people}</Label>
            </div>
            {groupedPermissions[PERMISSION_GROUP.PEOPLE][people].map((payer) =>
            <div style={styles.columnBody}>
              <div style={styles.checkBox}>
              <Checkbox disabled={isDisabled(payer.key)} checked={payer.value} onChangeCb={(e) => handlePermissionChange(payer.key, e.target.checked)}/>
              <Label>{payer.label}</Label>
            </div>
          </div>)}
            </div>
          )}
        </div>
      </div>
      <div style={styles.column}>
        <div style={styles.columnHeader}>
            <Checkbox checked={isAllSelected(PERMISSION_GROUP.TIN)} onChangeCb={(e)=>{handleBulkPermissionChange(PERMISSION_GROUP.TIN, e.target.checked)}}/>
            <Label>{PERMISSION_GROUP.TIN}</Label> 
        </div>
        <div style={styles.columnBody}>
          {
          groupedPermissions[PERMISSION_GROUP.TIN].map((TIN) =>
          <div style={styles.columnBody}>
            <div style={styles.checkBox}>
              <Checkbox disabled={isDisabled(TIN.key)} checked={TIN.value} onChangeCb={(e) => handlePermissionChange(TIN.key, e.target.checked)} />
              <Label>{TIN.label}</Label>
            </div>
          </div>
          )}
          </div>
      </div>
      <div style={styles.column}>
        <div style={styles.columnHeader}>
            <Checkbox checked={isAllSelected(PERMISSION_GROUP.IMPORT_DATA)} onChangeCb={(e)=>{handleBulkPermissionChange(PERMISSION_GROUP.IMPORT_DATA, e.target.checked)}}/>
            <Label>Import Data</Label> 
        </div>
        <div style={styles.columnBody}>
          {
          groupedPermissions[PERMISSION_GROUP.IMPORT_DATA].map((IMPORT) =>
          <div style={styles.columnBody}>
            <div style={styles.checkBox}>
              <Checkbox disabled={isDisabled(IMPORT.key)} checked={IMPORT.value} onChangeCb={(e) => handlePermissionChange(IMPORT.key, e.target.checked)} />
              <Label>{IMPORT.label}</Label>
            </div>
          </div>
          )}
          </div>
      </div>
      <div style={styles.column}>
        <div style={styles.columnHeader}>
            <Checkbox checked={isAllSelected(PERMISSION_GROUP.FORMS)} onChangeCb={(e)=>{handleBulkPermissionChange(PERMISSION_GROUP.FORMS, e.target.checked)}}/>
            <Label>{PERMISSION_GROUP.FORMS}</Label> 
        </div>
        <div style={styles.columnBody}>
          {
          groupedPermissions[PERMISSION_GROUP.FORMS].map((Form) =>
          <div style={styles.columnBody}>
            <div style={styles.checkBox}>
              <Checkbox disabled={isDisabled(Form.key)} checked={Form.value} onChangeCb={(e) => handlePermissionChange(Form.key, e.target.checked)} />
              <Label>{Form.label}</Label>
            </div>
          </div>
          )}
          </div>
      </div>
      <div style={styles.column}>
        <div style={styles.columnHeader}>
            <Checkbox checked={isAllSelected(PERMISSION_GROUP.PAYMENT)} onChangeCb={(e)=>{handleBulkPermissionChange(PERMISSION_GROUP.PAYMENT, e.target.checked)}}/>
            <Label>{PERMISSION_GROUP.PAYMENT}</Label> 
        </div>
        <div style={styles.columnBody}>
          {
          groupedPermissions[PERMISSION_GROUP.PAYMENT].map((Payment) =>
          <div style={styles.columnBody}>
            <div style={styles.checkBox}>
              <Checkbox disabled={isDisabled(Payment.key)}  checked={Payment.value} onChangeCb={(e) => handlePermissionChange(Payment.key, e.target.checked)}/>
              <Label>{Payment.label}</Label>
            </div>
          </div>
          )}
          </div>
      </div>
      <div style={styles.column}>
        <div style={styles.columnHeader}>
            <Checkbox checked={isAllSelected(PERMISSION_GROUP.EVENTS)} onChangeCb={(e)=>{handleBulkPermissionChange(PERMISSION_GROUP.EVENTS, e.target.checked)}}/>
            <Label>{PERMISSION_GROUP.EVENTS}</Label> 
        </div>
        <div style={styles.columnBody}>
          {
          groupedPermissions[PERMISSION_GROUP.EVENTS].map((Event) =>
          <div style={styles.columnBody}>
            <div style={styles.checkBox}>
              <Checkbox disabled={isDisabled(Event.key)} checked={Event.value} onChangeCb={(e) => handlePermissionChange(Event.key, e.target.checked)}/>
              <Label>{Event.label}</Label>
            </div>
          </div>
          )}
          </div>
      </div>
    </div>
    </div>
  )
}